const initialState = {
  data:[]
}

export const fileSetting = (state = initialState, action) => {
  switch (action.type) {
    case "FILE_SETTING": {
      return { ...state, data: action.data };
    };
    case "LOGOUT":
      return initialState;
    default:
      return state;
  }
};
